<template>
  <div class="cards-manager">
    <card-form v-if="delegatesLoaded"/>
    <span v-if="loadingDelegates">Loading delegates...</span>
    <span v-if="loadingMotions">Loading motions...</span>
  </div>
</template>

<script>
import CardForm from './CardForm.vue'
export default {
  name: 'CardsManager',
  components: {
    CardForm
  },
  data: function () {
    return {
      loadingDelegates: false,
      loadingMotions: false
    }
  },
  async created () {
    this.loadDelegates()
    this.loadMotions()
  },
  computed: {
    delegatesLoaded () {
      return !!this.$store.getters['delegates/all']
    }
  },
  methods: {
    async loadDelegates () {
      this.loadingDelegates = true
      await this.$store.dispatch('delegates/load')
      this.loadingDelegates = false
    },
    async loadMotions () {
      this.loadingMotions = true
      await this.$store.dispatch('motions/load')
      this.loadingMotions = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/CardsManager.vue